<template>
    <div>

        <!-- sidebar display -->
        <div v-if="format" class="text-center mt-6 p-4 break-word">
            <img v-if="image" :src="image" class="mx-auto"/>
            <h5 class="sau-pm-reset"><slot name="message"></slot></h5>
            <slot name="details"></slot>
        </div>

        <div v-else class="sau-bx bx-pad text-center">
            <img v-if="image" :src="image" class="mx-auto"/>
            <h5 class="sau-pm-reset"><slot name="message"></slot></h5>
            <slot name="details"></slot>
            <!-- Include 'Contact Support' if the prop is defined -->
            <a v-if="support" href="#" @click.prevent="actionSupport" class="sau-link-button sm sidebar-open">Contact Support</a>
        </div>

    </div>
</template>
<script>
    export default {
        props:['type', 'support', 'format'],
	    data() {
	        return {
                image: '',
	        };
        },
        created() {
            switch(this.type) {
                case 'error':
                    this.image = '/img/apiro-broken.gif';
                        break;
                case 'message':
                default:
                    this.image = '/img/apiro-msg.gif'
                        break;
            }
        }
    }
</script>
<style>
.break-word {
    overflow-wrap: break-word;
}
</style>
